module.exports = __webpack_public_path__ + "img/0100.9f86adf5.png";